import { render, staticRenderFns } from "./orderVideoItem.vue?vue&type=template&id=2a2142c4&scoped=true&lang=pug&"
import script from "./orderVideoItem.vue?vue&type=script&lang=js&"
export * from "./orderVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./orderVideoItem.vue?vue&type=style&index=0&id=2a2142c4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2142c4",
  null
  
)

export default component.exports